import { useContext, useEffect, useState, useRef } from "react";
import { DataContext } from "../../../context/DataContext";
import { petitions } from "../../../api/calls";
import { toast } from "sonner";
import Table from "../../componentsTable/TanStackTable";
import { useForm } from "react-hook-form";
import Select from "react-select";
import Swal from "sweetalert2";
import TableLoad from "../../componentsTools/TableLoad";
import { exportToExcel_v1 } from "../../componentsTools/ExportToExcel";
import customStyles from "../../../frontend/styles/select";

export default function Vehiculo() {
  const { session, idEmpresa } = useContext(DataContext);
  const [filtering, setFiltering] = useState("");
  const [vehiculos, setVehiculos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [marca, setMarca] = useState([]);
  const [modelo, setModelo] = useState([]);
  const [estado, setEstado] = useState([]);
  const [load, setLoad] = useState(true)

  //MODAL
  const modalRef1 = useRef(null);
  const modalRef2 = useRef(null);

  //FORMS
  const form1 = useForm();
  const form2 = useForm();

  const columns = [
    {
      header: "Placa",
      accessorKey: "placa",
    },
    {
      header: "Certificado incripcion",
      accessorKey: "certInscripcion",
    },
    {
      header: "Modelo",
      accessorKey: "modelo",
    },
    {
      header: "Contribuyente",
      accessorKey: "razon",
    },
    {
      header: "Observación",
      accessorKey: "observacion",
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      cell: ({ row }) => (
        <div className="btn-reveal-trigger position-static">
          <button
            className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
            type="button"
            data-bs-toggle="dropdown"
            data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
            data-bs-reference="parent"
          >
            <span className="fas fa-ellipsis-h fs-10"></span>
          </button>
          <div className="dropdown-menu dropdown-menu-end py-2">
            <button
              className="dropdown-item text-info"
              onClick={() => handleUpdate(row.original)}
            >
              Editar
            </button>
            <button
              className="dropdown-item text-danger"
              onClick={() => deleteVehiculo(row.original.placa)}
            >
              Eliminar
            </button>
          </div>
        </div>
      ),
    },
  ];

  const handleUpdate = (data) => {
    form2.setValue('placa', data.placa,{ shouldValidate: true })
    form2.setValue('idMarca', data.idMarca,{ shouldValidate: true })
    form2.setValue('idModelo', data.idModelo,{ shouldValidate: true })
    form2.setValue('certInscripcion', data.certInscripcion,{ shouldValidate: true })
    form2.setValue('idContrib', data.idContrib,{ shouldValidate: true })
    form2.setValue('observacion', data.observacion,{ shouldValidate: true })
    const modal = new window.bootstrap.Modal(modalRef2.current);
    modal.show();
  };

  const deleteVehiculo = async (placa) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Estas seguro/a?",
        text: "No podrás cancelar el proceso",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, eliminar",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const response = await petitions.deleteVehiculo(
            idEmpresa(),
            session().token,
            { placa }
          );
          if (response.status === "success") {
            if (response.data) {
              setEstado(!estado);
              toast.success("Vehiculo eliminado correctamente");
            } else {
              toast.warning("Ocurrió un problema, inténtelo mas tarde");
            }
          } else {
            var msg =
              typeof response.code === "string"
                ? response.message
                : response.data;
            toast.error(msg);
          }
        }
      });
  };

  useEffect(() => {
    const fetchVehiculos = async () => {
      setLoad(true);
      const obj = session();
      const response = await petitions.getVehiculos(idEmpresa(), obj.token);

      if (response.status === "success") {
        setVehiculos(response.data);
      } else {
        const msg =
          typeof response.code === "string"
            ? response.message
            : response.data;
        toast.error(msg);
      }

      setLoad(false);
    };

    fetchVehiculos();
  }, [estado, idEmpresa, session]);


  useEffect(() => {
    const fetchClientes = async () => {
      const obj = session();
      const response = await petitions.getClientesSelect(
        idEmpresa(),
        obj.token
      );

      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setClientes(array);
      } else {
        const msg =
          typeof response.code === "string"
            ? response.message
            : response.data;
        toast.error(msg);
      }
    };

    fetchClientes();
  }, [idEmpresa, session]);

  useEffect(() => {
    const fetchModeloMarca = async () => {
      const response = await petitions.getModeloMarca(
        idEmpresa(),
        session().token
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setModelo(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchModeloMarca();
  }, [session, idEmpresa]);

  useEffect(() => {
    const fetchMarca = async () => {
      const response = await petitions.getMarca(idEmpresa(), session().token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idMarca,
          label: e.descripcion,
        }));
        setMarca(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchMarca();
  }, [session, idEmpresa]);


  const sendVehiculo = form1.handleSubmit(async (data) => {
    const response = await petitions.insertVehiculo(
      idEmpresa(),
      session().token,
      data
    );
    if (response.status === "success") {
      if (response.data) {
        const modalInstance = window.bootstrap.Modal.getInstance(
          modalRef1.current
        );
        modalInstance.hide();
        setEstado(!estado);
        toast.success("Vehículo registrado correctamente");
        form1.reset();
      } else {
        toast.warning("Ocurrió un problema, inténtelo mas tarde");
      }
    } else {
      var msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  });

  const updateVehiculo = form2.handleSubmit(async (data) => {
    const response = await petitions.updateVehiculo(idEmpresa(), session().token, data)
    if (response.status === "success") {
      if (response.data) {
        const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
        modalInstance.hide();
        setEstado(!estado);
        toast.success("Vehiculo actualizado correctamente"); 
      }
      else{
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  });

  return (
    <>
      <div className="mb-9">
        <div className="row g-2 mb-4">
          <div className="col-auto">
            <h2 className="mb-0">Vehiculos</h2>
          </div>
        </div>
        <div className="mb-4">
          <div className="row g-10">
            <div className="col-auto">
              <div className="search-box">
                <input
                  className="form-control search-input search rounded-4 border-0 shadow-sm"
                  type="search"
                  placeholder="Buscar vehiculo"
                  aria-label="Search"
                  value={filtering}
                  onChange={(e) => setFiltering(e.target.value)}
                />
                <span className="fas fa-search search-box-icon"></span>
              </div>
            </div>
            <div className="col-auto">
              <button className="btn btn-link text-body me-4 px-0" onClick={() => exportToExcel_v1(vehiculos, columns,"vehiculos")}>
                <span className="fa-solid fa-file-export fs-9 me-2"></span>
                Exportar
              </button>
              <button
                className="btn btn-primary rounded-4"
                data-bs-toggle="modal"
                data-bs-target="#modalAgregarVehiculo"
              >
                <span className="fas fa-plus me-2"></span>Nuevo vehiculo
              </button>
            </div>
          </div>
        </div>
        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
          <div className="table-responsive scrollbar-overlay mx-n1 px-1">
            {load ? (
                <TableLoad />
            ) : (
              <Table
                data={vehiculos}
                columns={columns}
                filtering={filtering}
                setFiltering={setFiltering}
              />
            )}
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modalAgregarVehiculo"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Datos de vehiculo
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={sendVehiculo}>
              <div className="modal-body">
                <div className="mb-2">
                  <label className="form-label" htmlFor="placa">
                    Placa
                  </label>
                  <input
                    className="form-control rounded-4" 
                    type="text"
                    id="placa"
                    name="placa"
                    {...form1.register("placa", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                      minLength: {
                        value: 1,
                        message: "Mínimo 1 caracter",
                      },
                      maxLength: {
                        value: 10,
                        message: "La placa no debe ser mayor a 10 caracteres",
                      },
                    })}
                  />
                  {form1.formState.errors?.placa && (
                    <code>{form1.formState.errors.placa.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="placa">
                    Marca
                  </label>
                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    placeholder="Selecciona una marca"
                    styles={customStyles}
                    options={marca}
                    value={
                      marca.find(
                        (option) => option.value === form1.watch("idMarca")
                      ) || null
                    }
                    {...form1.register("idMarca", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                    })}
                    onChange={(event) => {
                      form1.setValue("idMarca", event.value);
                    }}
                  />
                  {form1.formState.errors?.idMarca && (
                    <code>{form1.formState.errors.idMarca.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="placa">
                    Modelo
                  </label>
                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    placeholder="Selecciona un modelo"
                    styles={customStyles}
                    options={modelo}
                    value={
                      modelo.find(
                        (option) => option.value === form1.watch("idModelo")
                      ) || null
                    }
                    {...form1.register("idModelo", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                    })}
                    onChange={(event) => {
                      form1.setValue("idModelo", event.value);
                    }}
                  />
                  {form1.formState.errors?.idModelo && (
                    <code>{form1.formState.errors.idModelo.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="certInscripcion">
                    Certificado de inscripción
                  </label>
                  <input
                    className="form-control rounded-5"
                    type="text"
                    id="certInscripcion"
                    name="certInscripcion"
                    {...form1.register("certInscripcion", {
                      maxLength: {
                        value: 10,
                        message:
                          "El certificado de inscripción no debe ser mayor a 10 caracteres",
                      },
                    })}
                  />
                  {form1.formState.errors?.certInscripcion && (
                    <code>
                      {form1.formState.errors.certInscripcion.message}
                    </code>
                  )}
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="certInscripcion">
                    Contribuyente
                  </label>
                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    placeholder="Selecciona un contribuyente"
                    styles={customStyles}
                    options={clientes}
                    value={
                      clientes.find(
                        (option) => option.value === form1.watch("idContrib")
                      ) || null
                    }
                    {...form1.register("idContrib", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                    })}
                    onChange={(event) => {
                      form1.setValue("idContrib", event.value);
                    }}
                  />
                  {form1.formState.errors?.idContrib && (
                    <code>{form1.formState.errors.idContrib.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="observacion">
                    Observación
                  </label>
                  <textarea
                    className="form-control rounded-4"
                    id="observacion"
                    name="observacion"
                    {...form1.register("observacion", {
                      maxLength: {
                        value: 100,
                        message:
                          "La observación no debe ser mayor a 100 caracteres",
                      },
                    })}
                  ></textarea>
                  {form1.formState.errors?.observacion && (
                    <code>{form1.formState.errors.observacion.message}</code>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Registrar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef2}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Editar vehículo
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={updateVehiculo}>
              <div className="modal-body">
                <div className="mb-2">
                  <label className="form-label" htmlFor="placa">
                    Placa
                  </label>
                  <input
                    type="text"
                    className="form-control rounded-4"
                    {...form2.register("placa", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                    })}
                    disabled
                  />
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="placa">
                    Marca
                  </label>
                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    placeholder="Selecciona una marca"
                    styles={customStyles}
                    options={marca}
                    value={
                      marca.find(
                        (option) => option.value === form2.watch("idMarca")
                      ) || null
                    }
                    {...form2.register("idMarca", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                    })}
                    onChange={(event) => {
                      form2.setValue("idMarca", event.value);
                    }}
                  />
                  {form2.formState.errors?.idMarca && (
                    <code>{form2.formState.errors.idMarca.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="modelo">
                    Modelo
                  </label>
                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    placeholder="Selecciona un modelo"
                    styles={customStyles}
                    options={modelo}
                    value={
                      modelo.find(
                        (option) => option.value === form2.watch("idModelo")
                      ) || null
                    }
                    {...form2.register("idModelo", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                    })}
                    onChange={(event) => {
                      form2.setValue("idModelo", event.value);
                    }}
                  />
                  {form2.formState.errors?.idModelo && (
                    <code>{form2.formState.errors.idModelo.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="certInscripcion">
                    Certificado de inscripción
                  </label>
                  <input
                    className="form-control rounded-4"
                    type="text"
                    {...form2.register("certInscripcion", {
                      maxLength: {
                        value: 10,
                        message:
                          "El certificado de inscripción no debe ser mayor a 10 caracteres",
                      },
                    })}
                  />
                  {form2.formState.errors?.certInscripcion && (
                    <code>
                      {form2.formState.errors.certInscripcion.message}
                    </code>
                  )}
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="idContrib">
                    Contribuyente
                  </label>
                  <Select
                    className="mb-0 mi-select mi-select-bordered"
                    classNamePrefix="rs"
                    placeholder="Selecciona un contribuyente"
                    styles={customStyles}
                    options={clientes}
                    value={
                      clientes.find(
                        (option) => option.value === form2.watch("idContrib")
                      ) || null
                    }
                    {...form2.register("idContrib", {
                      required: {
                        value: true,
                        message: "Este campo es obligatorio",
                      },
                    })}
                    onChange={(event) => {
                      form2.setValue("idContrib", event.value);
                    }}
                  />
                  {form2.formState.errors?.idContrib && (
                    <code>{form2.formState.errors.idContrib.message}</code>
                  )}
                </div>
                <div className="mb-2">
                  <label className="form-label" htmlFor="observacion">
                    Observación
                  </label>
                  <textarea
                    className="form-control rounded-4"
                    id="observacion"
                    name="observacion"
                    {...form2.register("observacion", {
                      maxLength: {
                        value: 100,
                        message:
                          "La observación no debe ser mayor a 100 caracteres",
                      },
                    })}
                  ></textarea>
                  {form2.formState.errors?.observacion && (
                    <code>{form2.formState.errors.observacion.message}</code>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Actualizar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
